import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AlertsPage, { getDefaultPageData } from "components/pages/AlertsPage";
import Classes from "model";

export default function CaptureAlertTypeSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "addEditAlertWidget", "alert", "type" ], "balanceAlert")
    .submit();

    return <AlertsPage data={ data } />;
}